<template>
  <div>
    <p>
      <v-btn @click="loadSkills">
        {{ total_sp == 0 ? "Load" : "Refresh" }} skills
      </v-btn>
    </p>

    <div v-if="total_sp > 0">
      <p>You have a total of {{ total_sp | add_commas }} skill points</p>
      <v-expansion-panels>
        <v-expansion-panel
          v-for="(skill_list, group) in skills"
          :key="group"
        >
          <v-expansion-panel-header>{{ group }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="item in skill_list" :key="item.skill.skill_id">
                    <td>
                      <v-tooltip top nudge-top="10" max-width="400">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{ item.skill.name }}</span>
                        </template>
                        <span>{{ item.skill.description }}</span>
                      </v-tooltip>
                    </td>
                    <td class="text-right">
                      <span
                        class="box"
                        v-for="n in item.level"
                        :key="`box-${n}`"
                      ></span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CharacterSkills",
  computed: {
    ...mapState({
      total_sp: "character_total_sp",
      skills: "character_skills",
    })
  },
  methods: {
    loadSkills() {
      this.loading = true;
      this.$store
        .dispatch("loadCharacterSkills")
        .then(() => (this.loading = false));
    }
  }
}
</script>
